import cloneDeep from 'lodash/cloneDeep'
import merge from 'lodash/merge'
import baseDefaults from '../Base/Base.defaults'
import baseSvgDefaults from '../BaseSvg/BaseSvg.defaults'

export default {
  ...cloneDeep(baseDefaults),
  layout: 'content-left',
  featureBackgroundColor: '#fff',
  featureBorderColor: '#ccc',
  quoteBackgroundColor: 'var(--color-primary)',
  quoteBorderColor: 'var(--color-primary)',
  quoteSvg: merge(cloneDeep(baseSvgDefaults))
}
